import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import styled from 'styled-components';
import { Draggable } from 'react-beautiful-dnd';
import LearnMoreModal from '../Components/layout/LearnMoreModal';

const Container = styled.div`
  border: 1px solid lightgrey;
  border-radius: 2px;
  padding: 8px;
  margin-bottom: 8px;
  background-color: white; //avoids see-thru when dragging
`;

const propTypes = {
  bodySiteLabel: PropTypes.string,
  bodySiteHelp: PropTypes.string
};

const defaultProps = {
  bodySiteLabel: 'Body Site',
  bodySiteHelp: 'Sorry, could not find help for this body site.'
};

//https://egghead.io/courses/beautiful-and-accessible-drag-and-drop-with-react-beautiful-dnd 
//https://stackoverflow.com/questions/41840759/how-to-vertically-center-a-text-in-a-column-bootstrap-4
//use of Rows and Cols allows text and help button to align vertically (className="my-auto")

class BodySiteItem extends React.Component {

  render(){
    const bodySiteLabel = this.props.bodySiteLabel;
    const bodySiteHelp = this.props.bodySiteHelp || defaultProps.bodySiteHelp;
    const title = "Help for " + bodySiteLabel;
    return (
      <Draggable draggableId={this.props.bodySiteId} index={this.props.index}>
          {provided => (
            <Container
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              ref={provided.innerRef}
            >
              <Row>
                <Col className="my-auto">
                  {bodySiteLabel}
                </Col>
                <Col>
                  <LearnMoreModal buttonClassName="float-end aa-no-padding" linkText="" title={title} content={bodySiteHelp} />
                </Col>
              </Row>
            </Container>
          )}
      </Draggable>
    );
  }
}

BodySiteItem.propTypes = propTypes;
BodySiteItem.defaultProps = defaultProps;

export default BodySiteItem;

//here's a way to align the text and button vertically
// https://stackoverflow.com/questions/48492915/how-to-vertical-align-button-contents-with-bootstrap-4
//but that doesn't allow the button to float right anymore
/* <Container className="d-flex align-items-center"
{...provided.draggableProps}
{...provided.dragHandleProps}
ref={provided.innerRef}
>
{this.props.bodySiteLabel}
<LearnMoreModal buttonClassName="float-right" linkText="" title="Body Site" content="more about this body site" />
</Container> */

